import { createContext } from '@lit/context'
import { BehaviorSubject, Subject } from 'rxjs'

/** Row shape for every <schmancy-step> in a stepper — a step reads this once at connect, never reactively. */
export type SchmancyStepsMode = 'content' | 'rail'

export class StepsController {
	private valueSubject = new BehaviorSubject(1)
	/** null = "as far as `value`" — the default that reproduces a plain forward-only stepper. */
	private reachedSubject = new BehaviorSubject<number | null>(null)
	private navigateRequestSubject = new Subject<number>()

	mode: SchmancyStepsMode = 'content'

	get value$() {
		return this.valueSubject.asObservable()
	}

	get value() {
		return this.valueSubject.value
	}

	/** The current-step channel — written only by <schmancy-steps>'s `.value=` setter. Never emits a navigate request. */
	setValue(value: number) {
		this.valueSubject.next(value)
	}

	get reached$() {
		return this.reachedSubject.asObservable()
	}

	get reached(): number | null {
		return this.reachedSubject.value
	}

	/** The furthest-reached channel — written only by <schmancy-steps>'s `.reached=` setter. */
	setReached(reached: number | null) {
		this.reachedSubject.next(reached)
	}

	get navigateRequest$() {
		return this.navigateRequestSubject.asObservable()
	}

	/** A navigable step's click — the host re-dispatches this as `navigate`. Never writes the current-step channel. */
	requestNavigate(value: number) {
		this.navigateRequestSubject.next(value)
	}
}

export const stepsContext = createContext<StepsController>(Symbol('SchmancyStepsContext'))
